export default interface ExtensionOption {
    id?: number
    object?: string
    type?: ExtensionOptionType
    data?: string[]
    name?: string
    created_at?: Date | string
    updated_at?: Date | string
    deleted_at?: Date | string
}

export enum ExtensionOptionType {
    date = 'date',
    text = 'text',
    phone = 'phone',
    number = 'number',
    dropdown = 'dropdown'
}